import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { empModulo } from '../../../diccionarios/empModulo';
import { CaracteristicaModel } from '../../../models/caracteristicaModel';
import { CargosService } from '../../../services/administrador/cargos.services';
import { MaracionesService } from '../../../services/administrador/marcaciones.services';



@Component({
  selector: 'app-mantener-marcaciones',
  templateUrl: './mantener-marcaciones.component.html',
  styleUrls: ['./mantener-marcaciones.component.css']
})
export class MantenerMarcacionesComponent implements OnInit {

  textoBuscar:string;
  resposiveFull: string;
  empModulo: any = {};

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  loading: boolean = false;
  listaVacia: boolean = true;
  dataEdit: CaracteristicaModel;
  banderaEdit: boolean = false;
  banderaSend: boolean = false;

  titulo:string = 'Crear nuevo cargo';

  constructor(
      private fb: FormBuilder,
      private _util: UtilsService,
      private _crearCargos: CargosService,
      private _marcaciones: MaracionesService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      descripcion: ['',[Validators.required]],
      codigo: [''],
    });
    this.cargarGrid();
    this.getAllusuariosMarcacion();
  }

  onKeydown(event) {
    //console.log(this.formulario.get('tarjeta').value);
    if ((event.key === 'Enter' || this.formulario.get('descripcion').value.length > 9)) {
      //this.enviarTarjeta(this.formulario.get('tarjeta').value);
      console.log(this.formulario.get('descripcion').value);
      this.banderaSend =false;
      this._marcaciones.findEmpleados(this.formulario.get('descripcion').value).subscribe((res: any) => {
        this.banderaSend = true;
        this.formulario.get('codigo').setValue(res.nombres);
        console.log(res);
      }, (err) => {
        this.banderaSend = false;
      });
  }
}

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'codEmpleado',
        filter: true,
        width: 150,
      },
      {
        headerName: 'NOMBRES',
        field: 'nombreEmpleado',
        sortable: true,
        width: 350,
        filter: true
      },
      {
        headerName: 'FECHA CREACIÓN',
        field: 'fechaCreacion',
        sortable: true,
        filter: true,
        width: 180,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.deletePuntoEntrega.bind(this),
          label: "Eliminar",
        }
      },

    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAllusuariosMarcacion(){
    this.loading = true;
    this._marcaciones.getUsuariosMarcaciones().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
      console.log(res);
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
    });
  }

  getAllCargos() {
    this.loading = true;
    this._crearCargos.getAllCargos().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
      console.log(res);
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.listaVacia = true;
    });
  }

  agregarPuntoEntrega() {
    if(!this.banderaSend){
      this._util.mensajeErrorVisto('EL usuario no existe', true, 9000);
      return;
    }  
    let cargosModel:CaracteristicaModel = new CaracteristicaModel();
    cargosModel.codigo = this.formulario.get('codigo').value;
    cargosModel.tipo = 'CARGO';
    cargosModel.descripcion = this.formulario.get('descripcion').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea agregar el siguiente Cargo?',
        text: '',
        action: 'Guardar',
        funcion: this._marcaciones.getCreateUsuariosMarcaciones(cargosModel.descripcion),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.formulario.reset();
      this.getAllusuariosMarcacion();
      document.getElementById('cerrarModal').click();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  deletePuntoEntrega({rowData}) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar el siguiente usuario de las marcaciones?',
        text: '',
        action: 'Eliminar',
        funcion: this._marcaciones.deleteUsuarioMaracion(rowData.codEmpleado),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllusuariosMarcacion();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  editarPuntoEntrega(){
    this.dataEdit.descripcion =  this.formulario.get('descripcion').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea editar el siguiente Cargo?',
        text: '',
        action: 'Editar',
        funcion: this._crearCargos.postCargos(this.dataEdit),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.getAllCargos();
      this.formulario.reset();
      this.dataEdit = null;
      document.getElementById('cerrarModal').click();
      this.formulario.get('codigo').enable();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callModal(){
    this.banderaEdit = false;
    this.titulo = 'Crear nuevo registro';
    document.getElementById('abrirModal').click();
  }

  callModalEdit({rowData}){
    this.banderaEdit = true;
    this.dataEdit = rowData;
    this.titulo = 'Editar el cargo';
    this.formulario.get('descripcion').setValue(this.dataEdit.descripcion);
    this.formulario.get('codigo').setValue(this.dataEdit.codigo);
    this.formulario.get('codigo').disable();
    document.getElementById('abrirModal').click();
  }
}
